import { useQuery } from '@tanstack/react-query';
import { getTaxonomies } from 'Services/categories';
import { trackError } from 'Utils/errorMonitoring';

export default function useTaxonomies(options = {}) {
    const { data: taxonomies = [], isLoading } = useQuery({
        queryKey: ['taxonomies'],
        queryFn: getTaxonomies,
        onError: (error) => trackError(error),
        ...options,
    });

    return {
        taxonomies,
        isLoading,
    };
}
